// src/auth/AuthProvider.tsx

import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { toast } from 'react-toastify';
// import { useAppDispatch } from '../Hooks';
// import { removeAuth } from '../features/auth/authSlice';

interface User {
    token: string;
    [key: string]: any; // Extendable for additional user properties
}

interface AuthContextType {
    user: User | null;
    login: (userData: User) => void;
    logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
    children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
    // const dispatch = useAppDispatch();
    const [user, setUser] = useState<User | null>(() => {
        const savedUser = localStorage.getItem('user');
        return savedUser ? JSON.parse(savedUser) as User : null;
    });

    const login = (userData: User) => {
        localStorage.setItem('user', JSON.stringify(userData));
        localStorage.setItem('token', userData.token);
        setUser(userData);
    };

    const logout = () => {
        localStorage.clear();
        setUser(null);
        toast.success("Logout successfully");
        // dispatch(removeAuth());
    };

    useEffect(() => {
        const savedUser = localStorage.getItem('user');
        const parsedUser: User | null = savedUser ? JSON.parse(savedUser) as User : null;
        if (!user) {
            setUser(parsedUser);
        }
    }, [user]);

    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = (): AuthContextType => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
};
